import ContactForm from "./components/ContactForm"
import ContactHero from "./components/ContactHero"

export default function ContactUs() {
  return (
    <>
      <section>
        <ContactHero />
        <ContactForm />
      </section>
    </>
  )
}
